export default __webpack_public_path__ + "static/media/left_button.775bd99e.svg";